import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MoveOrderService {

  constructor(private http: HttpClient) { }

  /**
   * Get move orders by giving a DO number.
   * @param doNo Delivery order number
   */
  getMoveOrdersByDONo(doNo: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/MoveOrder`;
    const headers = new HttpHeaders();
    const params = new HttpParams().append('doNo', doNo);

    return this.http.get(url, { headers, params });
  }

  /**
   * Get move order items by giving a PD Number.
   * @param pdNo PD number
   */
  getMoveOrderItemsByPDNo(pdNo: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/MoveOrderItem`;
    const headers = new HttpHeaders();
    const params = new HttpParams().append('pdNo', pdNo);

    return this.http.get(url, { headers, params });
  }

  /**
   * get Shippment Tracks
   * @param doNo
   */
  getShippmentTracks(doNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/Logistics/shippmentTracks/${doNo}`;
    const headers = new HttpHeaders();
    const params = new HttpParams();

    return this.http.get(url, { headers, params });
  }

  /**
   *
   * @param doNo getEstimated Date
   */
  getEstimatedDate(doNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/estimatedDate/${doNo}`;
    const headers = new HttpHeaders();
    const params = new HttpParams();

    return this.http.get(url, { headers, params });
  }

  getMoveOrderTrackingPercent(doNo: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/MoveOrderTracking/getOrderTrackingPercent/`
    const headers = new HttpHeaders();
    const params = new HttpParams().append("doNo",doNo);

    return this.http.get(url, {headers, params});
  }

  getMoveOrderTrackingAndFixedRemark(doNo: string, facility: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/moveOrder/getMoveOrderTrackingAndFixedRemark`;
    const headers = new HttpHeaders();
    const params = new HttpParams().append('doNo', doNo).append("facility",facility);

    return this.http.get(url, { headers, params });
  }
}
